module.exports = __webpack_public_path__ + "static/sport/bgi-pc.65ca511.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-sport/bgi-pc.webp
// module id = fpZk
// module chunks = 0